export const HOME_URL = '/home/index';

export const TABS_BLACK_LIST: string[] = ['/403', '/404', '/500', '/layout', '/login', '/dataScreen'];

// * 高德地图key
export const MAP_KEY = '';

export const AUTH_KEY = 'sInR5cCI6IkpXVCJ9.eyJ1c2VyTmFtZSI6Im1hcmljbyIsInVzZU';
